// 회원에게 노출되는 외부/정책 문서 링크의 단일 원천.
// 약관 개정으로 게시 문서가 바뀌면 여기만 수정한다(푸터·정책 페이지·동의 모달이 함께 참조).
export const TERMS_NOTION_URL = 'https://buttercup-coral-e9a.notion.site/3cdc00e56086807197bfe8d8adfaa140';
export const PRIVACY_NOTION_URL = 'https://buttercup-coral-e9a.notion.site/199c00e56086801c8ddafaae9a354388';
// 고객센터 카카오톡 채널 (정산 문의)
export const KAKAO_CHANNEL_URL = 'https://pf.kakao.com/_xjSxcxgxj';
// 「서비스 이용료 정책」 전문 페이지(로그인 전용 인앱 라우트)
export const SERVICE_FEE_POLICY_PATH = '/policy/service-fee';
